import React from 'react';
import { FeatureToggle } from 'react-feature-toggles';
import { useSelector } from 'react-redux';
import { FEATURE_FLAGS } from 'utils/constants';
import { RootState } from 'v2/models';

export interface FeatureToggleRerouterProps {
  featureName: FEATURE_FLAGS;
  children: React.ReactNode;
}

const FeatureToggleRerouter = ({
  featureName,
  children,
}: FeatureToggleRerouterProps) => {
  const user = useSelector((state: RootState) => state?.user?.user);

  if (!user) {
    return <>{children}</>;
  }

  return <FeatureToggle featureName={featureName}>{children}</FeatureToggle>;
};

export default FeatureToggleRerouter;
